export default __webpack_public_path__ + "static/media/spr-storyboarder-dark-large.35bd80f8.png";